"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniversalheaderProptypes = exports.MobileUniversalHeaderPropTypes = exports.DesktopUniversalHeaderPropTypes = void 0;
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = require("@airasia/phoenix-components/components/constant");
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var LoginConfig = {
  shouldSetCookie: _propTypes.default.bool.isRequired,
  reloadOnLogin: _propTypes.default.bool.isRequired,
  reloadOnLogout: _propTypes.default.bool,
  enableFavoriteMembers: _propTypes.default.bool,
  HideLoginIconForMobile: _propTypes.default.bool.isRequired,
  setDuplicateCookieAATokens: _propTypes.default.shape({
    cookieName: _propTypes.string,
    cookieExpiryInDays: _propTypes.number
  })
};
var UniversalheaderProptypes = {
  PropTypes: {
    children: _propTypes.default.node,
    background: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    data: _propTypes.default.object.isRequired,
    viewport: _propTypes.default.oneOf(Object.values(_constant2.DEVICE_TYPE)),
    customProperties: _propTypes.default.object,
    locale: _propTypes.default.string.isRequired,
    currency: _propTypes.default.string.isRequired,
    autoViewportOnLoad: _propTypes.default.bool,
    loginConfig: _propTypes.default.shape(LoginConfig).isRequired,
    environment: _propTypes.default.oneOf(Object.values(_constants.ENVIRONMENT)).isRequired,
    skipSelector: _propTypes.default.shape({
      content: _propTypes.default.string,
      footer: _propTypes.default.string
    }),
    onUserLoginStatus: _propTypes.default.func,
    fireGtm: _propTypes.default.func,
    showCurrency: _propTypes.default.bool,
    showLocale: _propTypes.default.bool,
    customHeadingEnabled: _propTypes.default.bool,
    customHeading: _propTypes.default.string,
    showSkipContent: _propTypes.default.bool,
    isScrollTop: _propTypes.default.bool,
    lobName: _propTypes.default.string,
    enableHotjar: _propTypes.default.bool,
    geoCountry: _propTypes.default.string,
    customOTAHeaderEnabled: _propTypes.default.bool,
    OTABackIconCallback: _propTypes.default.func,
    hideUHF: _propTypes.default.bool,
    monitorWebVital: _propTypes.default.bool,
    headerTextLimit: _propTypes.default.number,
    hasBoxShadow: _propTypes.default.bool
  },
  DefaultProps: {
    accessible: true,
    background: _constants.DEFAULT_STYLE.DEFAULT_BACKGROUND_COLOR,
    color: _constants.DEFAULT_STYLE.DEFAULT_TEXT_COLOR,
    theme: _constant.DEFAULT_THEME,
    viewport: _constant2.DEVICE_TYPE.DESKTOP,
    locale: _constants.DEFAULT_LOCALE,
    autoViewportOnLoad: false,
    currency: _constants.DEFAULT_CURRENCY,
    loginConfig: {
      shouldSetCookie: false,
      reloadOnLogin: false,
      reloadOnLogout: true,
      HideLoginIconForMobile: false,
      enableBigPoints: true,
      enableCreditBalance: false,
      enableFavoriteMembers: false
    },
    skipSelector: {
      content: '#airasia-product-tiles',
      footer: '#airasia-above-footer'
    },
    showCurrency: true,
    showLocale: true,
    onUserLoginStatus: function onUserLoginStatus() {},
    customHeadingEnabled: false,
    customHeading: '',
    customOTAHeaderEnabled: false,
    showSkipContent: true,
    isScrollTop: false,
    enableHotjar: false,
    lobName: '',
    hideUHF: false,
    monitorWebVital: false,
    hasBoxShadow: true
  }
};
exports.UniversalheaderProptypes = UniversalheaderProptypes;
var MobileUniversalHeaderPropTypes = {
  PropTypes: {
    theme: _propTypes.default.string,
    background: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    accessible: _propTypes.default.bool,
    children: _propTypes.default.node,
    data: _propTypes.default.object,
    mobileDataInsideLeftPane: _propTypes.default.array,
    loginConfig: _propTypes.default.shape(LoginConfig),
    environment: _propTypes.default.oneOf(Object.values(_constants.ENVIRONMENT)),
    onUserLoginStatus: _propTypes.default.func,
    gtmParameters: _propTypes.default.object,
    fireGtm: _propTypes.default.func,
    showCurrency: _propTypes.default.bool,
    showChangeCurrency: _propTypes.default.bool,
    showLocale: _propTypes.default.bool,
    idConfig: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      parentName: _propTypes.default.string,
      index: _propTypes.default.string
    }),
    customHeadingEnabled: _propTypes.default.bool,
    customHeading: _propTypes.default.string,
    customOTAHeaderEnabled: _propTypes.default.bool,
    OTABackIconCallback: _propTypes.default.func,
    secretKey: _propTypes.default.string,
    getInfoConfigTokens: _propTypes.default.func,
    callCreditEndpointV2: _propTypes.default.bool,
    headerTextLimit: _propTypes.default.number,
    hasBoxShadow: _propTypes.default.bool
  },
  DefaultProps: {
    background: _constants.DEFAULT_STYLE.DEFAULT_BACKGROUND_COLOR,
    color: _constants.DEFAULT_STYLE.DEFAULT_TEXT_COLOR,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    showCurrency: true,
    showLocale: true,
    showChangeCurrency: false,
    onUserLoginStatus: function onUserLoginStatus() {},
    customHeadingEnabled: false,
    customHeading: '',
    customOTAHeaderEnabled: false,
    hasBoxShadow: true
  }
};
exports.MobileUniversalHeaderPropTypes = MobileUniversalHeaderPropTypes;
var DesktopUniversalHeaderPropTypes = {
  PropTypes: {
    theme: _propTypes.default.string,
    background: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    accessible: _propTypes.default.bool,
    children: _propTypes.default.node,
    data: _propTypes.default.object,
    leftComponents: _propTypes.default.array,
    rightComponents: _propTypes.default.array,
    loginConfig: _propTypes.default.shape(LoginConfig),
    environment: _propTypes.default.oneOf(Object.values(_constants.ENVIRONMENT)),
    onUserLoginStatus: _propTypes.default.func,
    gtmParameters: _propTypes.default.object,
    fireGtm: _propTypes.default.func,
    showCurrency: _propTypes.default.bool,
    showLocale: _propTypes.default.bool,
    customPadding: _propTypes.default.string,
    idConfig: _propTypes.default.exact({
      widgetName: _propTypes.default.string,
      parentName: _propTypes.default.string,
      index: _propTypes.default.string
    }),
    isScrollTop: _propTypes.default.bool,
    secretKey: _propTypes.default.string,
    getInfoConfigTokens: _propTypes.default.func,
    callCreditEndpointV2: _propTypes.default.bool
  },
  DefaultProps: {
    background: _constants.DEFAULT_STYLE.DEFAULT_BACKGROUND_COLOR,
    color: _constants.DEFAULT_STYLE.DEFAULT_TEXT_COLOR,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    showCurrency: true,
    showLocale: true,
    onUserLoginStatus: function onUserLoginStatus() {},
    isScrollTop: false
  }
};
exports.DesktopUniversalHeaderPropTypes = DesktopUniversalHeaderPropTypes;